import React, {useState} from 'react';

import ModalAddGroup from 'components/Group/ModalAddGroup';

function AddGroup(props) {
	const {
		disabled
	} = props;
	const [openModalAddGroup, setOpenModalAddGroup] = useState(false);

	return (
		<>
			<button
				className={'btntool addTool btn btn-primary p-0' + (disabled ? ' disabled' : '')}
				type="button"
				onClick={() => {
					setOpenModalAddGroup(true);
				}}
			>
				<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
				     fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
				     strokeLinejoin="round" className="cs-icon cs-icon-plus">
					<path d="M10 17 10 3M3 10 17 10"></path>
				</svg>
			</button>

			<ModalAddGroup
				forceOpen={openModalAddGroup}
				setForceOpenOpen={setOpenModalAddGroup}
			/>
		</>
	);
}

export default AddGroup;
